import parseDuration from 'parse-duration';

export const periodObject = [
  { label: 'alarms.periods.last_8_hours', value: '8h0m' },
  { label: 'alarms.periods.last_24_hours', value: '24h0m' },
  { label: 'alarms.periods.last_7_days', value: `${parseDuration('7d', 'h')}h0m` },
  { label: 'alarms.periods.last_30_days', value: `${parseDuration('30d', 'h')}h0m` },
  { label: 'alarms.periods.last_90_days', value: `${parseDuration('90d', 'h')}h0m` }
];
